var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "wrapper task-list" }, [
    _c("header", { staticClass: "header" }, [
      _c(
        "div",
        {
          staticClass: "back",
          on: {
            click: function ($event) {
              return _vm.$router.back()
            },
          },
        },
        [
          _c("img", { attrs: { src: require("images/back.png"), width: "8" } }),
          _c("span", [_vm._v("返回")]),
        ]
      ),
    ]),
    _c("div", { staticClass: "main" }, [
      _c(
        "div",
        { staticClass: "data-container" },
        [
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "justify-content": "space-between",
              },
            },
            [
              _c("span", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.taskName) + "分班记录列表"),
              ]),
              _c(
                "span",
                [
                  _c(
                    "el-button",
                    { attrs: { type: "text" }, on: { click: _vm.addRecord } },
                    [_vm._v("新增记录")]
                  ),
                  _c(
                    "el-button",
                    { attrs: { type: "text" }, on: { click: _vm.refresh } },
                    [_vm._v("刷新")]
                  ),
                ],
                1
              ),
            ]
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              attrs: { stripe: "", data: _vm.dataList },
            },
            [
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "recordName",
                  label: "记录名称",
                },
              }),
              _c("el-table-column", {
                attrs: { align: "center", prop: "recordStatus", label: "状态" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.recordStatus === 0
                          ? _c("div", [
                              _c("span", { staticStyle: { color: "red" } }, [
                                _vm._v("未保存"),
                              ]),
                            ])
                          : _vm._e(),
                        scope.row.recordStatus === 1
                          ? _c("div", [
                              _c("span", { staticStyle: {} }, [
                                _c("i", { staticClass: "el-icon-loading" }),
                              ]),
                              _c("span", { staticStyle: {} }, [
                                _vm._v("正在保存"),
                              ]),
                            ])
                          : _vm._e(),
                        scope.row.recordStatus === 2
                          ? _c("div", [
                              _c(
                                "span",
                                { staticStyle: { color: "#50C890" } },
                                [_c("i", { staticClass: "el-icon-success" })]
                              ),
                              _c(
                                "span",
                                { staticStyle: { color: "#50C890" } },
                                [_vm._v("保存完成")]
                              ),
                            ])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "操作" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.recordDetail(scope.row)
                              },
                            },
                          },
                          [_vm._v("查看")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.delRecord(scope.row)
                              },
                            },
                          },
                          [_vm._v("删除")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.exportRecord(scope.row)
                              },
                            },
                          },
                          [_vm._v("导出")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.updateRecord(scope.row)
                              },
                            },
                          },
                          [_vm._v("编辑")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }